import { render } from "./questionnaire_i.vue?vue&type=template&id=1484b027&scoped=true"
import script from "./questionnaire_i.vue?vue&type=script&lang=js"
export * from "./questionnaire_i.vue?vue&type=script&lang=js"

import "./questionnaire_i.vue?vue&type=style&index=0&id=1484b027&lang=scss&scoped=true"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1484b027"]])

export default __exports__